import React, { useState } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import Banner from '../Components/Banner';
import { ChevronRight } from 'lucide-react';
import { Helmet } from "react-helmet-async";
import LocationForm from '../Components/mumbai/LocationForm';
import ServiceNowLeadForm from '../Components/ServiceNowLeadForm';
function ServiceNowStaffAugmentation() {
const servicenowFaqData = [
    {
        id: 1,
        question: "What is ServiceNow staff augmentation?",
        answer:
            "ServiceNow staff augmentation helps businesses extend their teams with experienced ServiceNow developers, consultants, architects, administrators, and QA professionals."
    },
    {
        id: 2,
        question: "What ServiceNow professionals can I hire?",
        answer:
            "You can hire ServiceNow developers, consultants, architects, administrators, business analysts, QA engineers, and integration specialists."
    },
    {
        id: 3,
        question: "Which ServiceNow modules do you support?",
        answer:
            "We support ITSM, ITOM, CMDB, CSM, HRSD, integrations, custom applications, workflow automation, and ServiceNow support."
    },
    {
        id: 4,
        question: "Can your resources work with our existing team?",
        answer:
            "Yes. Our ServiceNow professionals can seamlessly work with your internal teams, existing partners, tools, and development processes."
    },
    {
        id: 5,
        question: "Can I hire resources for a specific project?",
        answer:
            "Yes. You can hire dedicated ServiceNow professionals for implementations, integrations, upgrades, custom development, automation, or ongoing support."
    },
    {
        id: 6,
        question: "Why choose Mobikode for ServiceNow staff augmentation?",
        answer:
            "Mobikode provides skilled ServiceNow professionals with flexible staffing options to help businesses scale teams, fill skill gaps, and accelerate project delivery."
    }
];

      const [activeIndex, setActiveIndex] = useState(0);
      const [faqActiveIndex, setFaqActiveIndex] = useState(0);

const toggleFaqAccordion = (index) => {
    setFaqActiveIndex(faqActiveIndex === index ? -1 : index);
};
  return (

    <div>
   <Helmet>
    {/* Primary SEO */}
    <title>
        ServiceNow Staff Augmentation Services | Mobikode
    </title>

    <meta
        name="description"
        content="Scale your ServiceNow team with experienced developers, consultants, architects, administrators, and QA professionals. Mobikode offers flexible ServiceNow staff augmentation and resource augmentation services."
    />

    <meta
        name="keywords"
        content="ServiceNow staff augmentation, ServiceNow resource augmentation, ServiceNow team augmentation, ServiceNow staffing, hire ServiceNow developers, ServiceNow developers, ServiceNow consultants, ServiceNow architects, ServiceNow administrators, dedicated ServiceNow team"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/servicenow-staff-augmentation/"
    />


    {/* Open Graph */}
    <meta
        property="og:title"
        content="ServiceNow Staff Augmentation Services | Mobikode"
    />

    <meta
        property="og:description"
        content="Extend your ServiceNow team with experienced developers, consultants, architects, administrators, and integration specialists through flexible staff and resource augmentation."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/servicenow-staff-augmentation/"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:site_name"
        content="Mobikode"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/services/servicenow-staff-augmentation.jpg"
    />

    <meta
        property="og:image:alt"
        content="ServiceNow Staff Augmentation Services by Mobikode"
    />


    {/* Twitter / X */}
    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="ServiceNow Staff Augmentation Services | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Scale your ServiceNow team with experienced developers, consultants, architects, administrators, and QA professionals."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/services/servicenow-staff-augmentation.jpg"
    />

    <meta
        name="twitter:image:alt"
        content="ServiceNow Staff Augmentation Services by Mobikode"
    />
</Helmet>
      <section className="relative h-[500px] lg:h-[630px] w-full overflow-hidden bg-[#0a0b1e]">
    <div className="absolute inset-0 z-0">
        <img
            src="/assets/services/bg3.png"
            alt="ServiceNow staff augmentation and resource augmentation services"
            className="h-full w-full object-cover opacity-40"
        />

        <div className="absolute inset-0 bg-gradient-to-b lg:bg-gradient-to-r from-[#0a0b1e] via-[#0a0b1e]/80 to-transparent opacity-90" />
    </div>

    <div className="relative z-10 flex h-full max-w-[1440px] w-full mx-auto flex-col justify-between px-6 lg:px-20 pt-20 pb-[60px]">

        {/* Hero Heading */}
        <motion.div
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
            className="lg:mt-[115px] mt-[40px]"
        >
            <h1 className="text-[38px] lg:text-[55px] text-[#FFFFFF] max-w-[800px] w-full font-sora font-[600] leading-[1.2] mb-[22px]">
                ServiceNow Staff Augmentation Services
            </h1>

            <p className="text-[#FFFFFF] font-graphik text-[16px] md:text-[20px] font-[400] leading-[1.6] mb-4">
                Extend Your ServiceNow Team with Experienced Professionals
            </p>
        </motion.div>

        {/* Hero Description */}
        <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            viewport={{ once: true }}
            className="mt-12 lg:self-end max-w-full lg:max-w-[501px] lg:ml-auto text-left md:mt-0"
        >
            <p className="text-[#FFFFFF] font-graphik text-[14px] md:text-[16px] font-[400] leading-[1.6]">
                Scale your ServiceNow capabilities with experienced developers,
                consultants, architects, administrators, and QA professionals.
                Mobikode provides flexible ServiceNow staff augmentation and
                resource augmentation services to help enterprises accelerate
                implementations, integrations, custom development, and ongoing
                ServiceNow operations.
            </p>
        </motion.div>

    </div>
</section>



<section className="bg-[#FFFFFF] overflow-hidden lg:py-[100px] py-[60px]">
    <div className="max-w-[1440px] w-full mx-auto lg:px-[80px] px-[20px]">

        <div className="flex flex-col lg:flex-row items-center gap-[40px] lg:gap-[80px]">

            {/* LEFT IMAGE */}
            <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
                className="w-full lg:w-1/2"
            >
                <div className="w-full h-[280px] md:h-[380px] lg:h-[450px] overflow-hidden">
                    <img
                        src="/assets/sales/img2.png"
                        alt="ServiceNow staff augmentation team and technical professionals"
                        className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                    />
                </div>
            </motion.div>

            {/* RIGHT CONTENT */}
            <div className="w-full lg:w-1/2 text-left">

                {/* Service Overview Label */}
                <motion.div
                    initial={{ opacity: 0, y: -15 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="flex items-center gap-[10px] pb-[15px] lg:pb-[20px]"
                >
                    <motion.span
                        className="font-[500] font-graphik text-[16px] lg:text-[20px] leading-[1.6] text-[#01386A]"
                    >
                        Service Overview
                    </motion.span>
                </motion.div>

                {/* Title */}
                <motion.h2
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.2 }}
                    className="font-[600] font-sora lg:text-[30px] max-w-[850px] w-full text-[20px] leading-[1.3] text-[#01386A]"
                >
                    Scale Your ServiceNow Capabilities with the Right Talent
                </motion.h2>

                {/* Description */}
                <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.35 }}
                    className="font-[400] max-w-[800px] w-full font-graphik text-[14px] lg:text-[16px] leading-[1.6] lg:leading-[22px] text-[#01386A] mt-[20px] lg:mt-[25px]"
                >
                    Our ServiceNow staff augmentation services help enterprises
                    strengthen their technology teams with experienced ServiceNow
                    professionals. Whether you need additional developers for an
                    implementation, consultants for platform optimization,
                    architects for enterprise solutions, or administrators for
                    ongoing operations, Mobikode provides skilled resources
                    aligned with your project requirements.

                    <br /><br />

                    Our flexible resource augmentation model allows you to scale
                    your ServiceNow team without the long-term overhead of
                    traditional hiring. From ITSM, ITOM, CMDB, CSM, and HRSD to
                    integrations, custom application development, workflow
                    automation, and platform upgrades, our professionals can work
                    alongside your existing teams to accelerate delivery and
                    support your ServiceNow initiatives.
                </motion.p>

                {/* Bottom Accent */}
                <motion.div
                    initial={{ width: 0 }}
                    whileInView={{ width: "70px" }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.5, duration: 0.6 }}
                    className="h-[3px] bg-[#ED6800] mt-[25px] lg:mt-[35px]"
                />

            </div>

        </div>

    </div>
</section>

<section className="w-full bg-[#FDFDFD] py-16 lg:py-24 relative">
    <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] relative z-10">

        {/* Main Flex Container */}
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-20 items-start">

            {/* Left Side: Title Section */}
            <div className="w-full lg:w-[40%] lg:sticky lg:top-24">
                <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] text-left">
                    ServiceNow Professionals for Every Project Need
                </h2>
            </div>


            {/* Right Side: Cards List Section */}
            <div className="w-full lg:w-[60%] flex flex-col gap-6">

                {/* Card 1 */}
                <div className="bg-white border border-[#E2E8F0] border-b-[4px] border-b-[#01386A] hover:border-b-[#e86c15] transition-colors duration-300 p-8 lg:px-10 lg:py-10 flex flex-col justify-center cursor-pointer group">
                    <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora mb-2">
                        ServiceNow Developers
                    </h3>
                    <p className="text-[#49577A] text-[14px] lg:text-[16px] font-[500] font-graphik leading-snug">
                        Add experienced ServiceNow developers to your team for
                        scripting, workflows, custom applications, business rules,
                        UI policies, Service Portal, and platform customization.
                        Our developers can support both new implementations and
                        ongoing ServiceNow development.
                    </p>
                </div>


                {/* Card 2 */}
                <div className="bg-white border border-[#E2E8F0] border-b-[4px] border-b-[#01386A] hover:border-b-[#e86c15] transition-colors duration-300 p-8 lg:px-10 lg:py-10 flex flex-col justify-center cursor-pointer group">
                    <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora mb-2">
                        ServiceNow Consultants
                    </h3>
                    <p className="text-[#49577A] text-[14px] lg:text-[16px] font-[500] font-graphik leading-snug">
                        Strengthen your ServiceNow team with consultants experienced
                        in requirements analysis, process optimization, implementation
                        planning, platform strategy, and ServiceNow transformation
                        initiatives.
                    </p>
                </div>


                {/* Card 3 */}
                <div className="bg-white border border-[#E2E8F0] border-b-[4px] border-b-[#01386A] hover:border-b-[#e86c15] transition-colors duration-300 p-8 lg:px-10 lg:py-10 flex flex-col justify-center cursor-pointer group">
                    <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora mb-2">
                        ServiceNow Architects
                    </h3>
                    <p className="text-[#49577A] text-[14px] lg:text-[16px] font-[500] font-graphik leading-snug">
                        Support complex ServiceNow programs with architects who
                        can define scalable platform architecture, integration
                        strategies, data models, governance, and enterprise-wide
                        technical solutions.
                    </p>
                </div>


                {/* Card 4 */}
                <div className="bg-white border border-[#E2E8F0] border-b-[4px] border-b-[#01386A] hover:border-b-[#e86c15] transition-colors duration-300 p-8 lg:px-10 lg:py-10 flex flex-col justify-center cursor-pointer group">
                    <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora mb-2">
                        ServiceNow Administrators
                    </h3>
                    <p className="text-[#49577A] text-[14px] lg:text-[16px] font-[500] font-graphik leading-snug">
                        Extend your ServiceNow operations team with administrators
                        supporting platform configuration, user management,
                        workflows, access controls, upgrades, maintenance, and
                        day-to-day ServiceNow administration.
                    </p>
                </div>


                {/* Card 5 */}
                <div className="bg-white border border-[#E2E8F0] border-b-[4px] border-b-[#01386A] hover:border-b-[#e86c15] transition-colors duration-300 p-8 lg:px-10 lg:py-10 flex flex-col justify-center cursor-pointer group">
                    <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora mb-2">
                        ServiceNow Integration Specialists
                    </h3>
                    <p className="text-[#49577A] text-[14px] lg:text-[16px] font-[500] font-graphik leading-snug">
                        Connect ServiceNow with your enterprise ecosystem through
                        integration specialists experienced in REST and SOAP APIs,
                        IntegrationHub, third-party systems, data synchronization,
                        and automated enterprise workflows.
                    </p>
                </div>


                {/* Card 6 */}
                <div className="bg-white border border-[#E2E8F0] border-b-[4px] border-b-[#01386A] hover:border-b-[#e86c15] transition-colors duration-300 p-8 lg:px-10 lg:py-10 flex flex-col justify-center cursor-pointer group">
                    <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora mb-2">
                        ServiceNow QA & Testing Professionals
                    </h3>
                    <p className="text-[#49577A] text-[14px] lg:text-[16px] font-[500] font-graphik leading-snug">
                        Improve ServiceNow release quality with QA professionals
                        experienced in functional testing, regression testing,
                        integration testing, workflow validation, and quality
                        assurance across ServiceNow projects.
                    </p>
                </div>

            </div>

        </div>

    </div>
</section>



<section className="w-full bg-white py-16 lg:py-24">
    <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">

        <h2 className="text-[#01386A] text-[20px] md:text-[30px] font-[600] font-sora mb-6 lg:mb-10 text-left">
            ServiceNow Staff Augmentation Expertise
        </h2>

        <div className="flex flex-col lg:flex-row gap-12 lg:gap-24">

            {/* LEFT SIDE - TABS */}
            <div className="lg:w-1/2 flex flex-col">

                {/* ITSM */}
                <div
                    onClick={() => setActiveIndex(0)}
                    className={`group cursor-pointer flex items-center justify-between py-6 lg:py-8 border-b-[3px] transition-all duration-300 ${
                        activeIndex === 0
                            ? "border-[#ED6800]"
                            : "border-gray-300 hover:border-gray-600"
                    }`}
                >
                    <h3
                        className={`text-[16px] md:text-[20px] font-[600] font-sora transition-colors duration-300 ${
                            activeIndex === 0
                                ? "text-[#01386A]"
                                : "text-[#0000008C] group-hover:text-gray-600"
                        }`}
                    >
                        ServiceNow ITSM
                    </h3>

                    <ChevronRight
                        size={24}
                        className={`transition-all duration-300 ${
                            activeIndex === 0
                                ? "opacity-100 translate-x-0 text-[#ED6800]"
                                : "opacity-0 -translate-x-4 text-gray-300"
                        }`}
                    />
                </div>


                {/* ITOM & CMDB */}
                <div
                    onClick={() => setActiveIndex(1)}
                    className={`group cursor-pointer flex items-center justify-between py-6 lg:py-8 border-b-[3px] transition-all duration-300 ${
                        activeIndex === 1
                            ? "border-[#ED6800]"
                            : "border-gray-300 hover:border-gray-600"
                    }`}
                >
                    <h3
                        className={`text-[16px] md:text-[20px] font-[600] font-sora transition-colors duration-300 ${
                            activeIndex === 1
                                ? "text-[#01386A]"
                                : "text-[#0000008C] group-hover:text-gray-600"
                        }`}
                    >
                        ServiceNow ITOM & CMDB
                    </h3>

                    <ChevronRight
                        size={24}
                        className={`transition-all duration-300 ${
                            activeIndex === 1
                                ? "opacity-100 translate-x-0 text-[#ED6800]"
                                : "opacity-0 -translate-x-4 text-gray-300"
                        }`}
                    />
                </div>


                {/* CSM */}
                <div
                    onClick={() => setActiveIndex(2)}
                    className={`group cursor-pointer flex items-center justify-between py-6 lg:py-8 border-b-[3px] transition-all duration-300 ${
                        activeIndex === 2
                            ? "border-[#ED6800]"
                            : "border-gray-300 hover:border-gray-600"
                    }`}
                >
                    <h3
                        className={`text-[16px] md:text-[20px] font-[600] font-sora transition-colors duration-300 ${
                            activeIndex === 2
                                ? "text-[#01386A]"
                                : "text-[#0000008C] group-hover:text-gray-600"
                        }`}
                    >
                        ServiceNow CSM
                    </h3>

                    <ChevronRight
                        size={24}
                        className={`transition-all duration-300 ${
                            activeIndex === 2
                                ? "opacity-100 translate-x-0 text-[#ED6800]"
                                : "opacity-0 -translate-x-4 text-gray-300"
                        }`}
                    />
                </div>


                {/* HRSD */}
                <div
                    onClick={() => setActiveIndex(3)}
                    className={`group cursor-pointer flex items-center justify-between py-6 lg:py-8 border-b-[3px] transition-all duration-300 ${
                        activeIndex === 3
                            ? "border-[#ED6800]"
                            : "border-gray-300 hover:border-gray-600"
                    }`}
                >
                    <h3
                        className={`text-[16px] md:text-[20px] font-[600] font-sora transition-colors duration-300 ${
                            activeIndex === 3
                                ? "text-[#01386A]"
                                : "text-[#0000008C] group-hover:text-gray-600"
                        }`}
                    >
                        ServiceNow HRSD
                    </h3>

                    <ChevronRight
                        size={24}
                        className={`transition-all duration-300 ${
                            activeIndex === 3
                                ? "opacity-100 translate-x-0 text-[#ED6800]"
                                : "opacity-0 -translate-x-4 text-gray-300"
                        }`}
                    />
                </div>


                {/* Integrations */}
                <div
                    onClick={() => setActiveIndex(4)}
                    className={`group cursor-pointer flex items-center justify-between py-6 lg:py-8 border-b-[3px] transition-all duration-300 ${
                        activeIndex === 4
                            ? "border-[#ED6800]"
                            : "border-gray-300 hover:border-gray-600"
                    }`}
                >
                    <h3
                        className={`text-[16px] md:text-[20px] font-[600] font-sora transition-colors duration-300 ${
                            activeIndex === 4
                                ? "text-[#01386A]"
                                : "text-[#0000008C] group-hover:text-gray-600"
                        }`}
                    >
                        ServiceNow Integrations
                    </h3>

                    <ChevronRight
                        size={24}
                        className={`transition-all duration-300 ${
                            activeIndex === 4
                                ? "opacity-100 translate-x-0 text-[#ED6800]"
                                : "opacity-0 -translate-x-4 text-gray-300"
                        }`}
                    />
                </div>


                {/* Custom Development */}
                <div
                    onClick={() => setActiveIndex(5)}
                    className={`group cursor-pointer flex items-center justify-between py-6 lg:py-8 border-b-[3px] transition-all duration-300 ${
                        activeIndex === 5
                            ? "border-[#ED6800]"
                            : "border-gray-300 hover:border-gray-600"
                    }`}
                >
                    <h3
                        className={`text-[16px] md:text-[20px] font-[600] font-sora transition-colors duration-300 ${
                            activeIndex === 5
                                ? "text-[#01386A]"
                                : "text-[#0000008C] group-hover:text-gray-600"
                        }`}
                    >
                        Custom ServiceNow Development
                    </h3>

                    <ChevronRight
                        size={24}
                        className={`transition-all duration-300 ${
                            activeIndex === 5
                                ? "opacity-100 translate-x-0 text-[#ED6800]"
                                : "opacity-0 -translate-x-4 text-gray-300"
                        }`}
                    />
                </div>

            </div>


            {/* RIGHT SIDE - CONTENT */}
            <div className="lg:w-1/2 flex flex-col justify-start">

                <div className="min-h-[100px] mb-8">

                    {activeIndex === 0 && (
                        <p className="text-[#49577A] text-[14px] lg:text-[16px] leading-relaxed font-[500] font-graphik animate-fade-in">
                            Strengthen your ServiceNow ITSM initiatives with
                            experienced professionals who can support incident,
                            problem, change, request, and knowledge management.
                            Our augmented resources can work alongside your
                            existing team to improve workflows, automate processes,
                            and accelerate IT service delivery.
                        </p>
                    )}

                    {activeIndex === 1 && (
                        <p className="text-[#49577A] text-[14px] lg:text-[16px] leading-relaxed font-[500] font-graphik animate-fade-in">
                            Extend your ServiceNow ITOM and CMDB capabilities with
                            skilled professionals experienced in discovery, service
                            mapping, configuration management, event management,
                            and infrastructure visibility. Add specialized resources
                            to support complex IT operations and ServiceNow
                            transformation initiatives.
                        </p>
                    )}

                    {activeIndex === 2 && (
                        <p className="text-[#49577A] text-[14px] lg:text-[16px] leading-relaxed font-[500] font-graphik animate-fade-in">
                            Enhance customer service operations with ServiceNow CSM
                            professionals who can support case management, customer
                            portals, workflows, automation, and integrations. Add
                            specialized resources to help your team build connected
                            and efficient customer service experiences.
                        </p>
                    )}

                    {activeIndex === 3 && (
                        <p className="text-[#49577A] text-[14px] lg:text-[16px] leading-relaxed font-[500] font-graphik animate-fade-in">
                            Strengthen employee service delivery with ServiceNow HRSD
                            professionals experienced in employee workflows, case
                            management, HR service delivery, and platform
                            integrations. Our resources can support HRSD implementations,
                            enhancements, and ongoing ServiceNow initiatives.
                        </p>
                    )}

                    {activeIndex === 4 && (
                        <p className="text-[#49577A] text-[14px] lg:text-[16px] leading-relaxed font-[500] font-graphik animate-fade-in">
                            Connect ServiceNow with your enterprise applications using
                            experienced integration specialists. Our resources support
                            REST and SOAP APIs, IntegrationHub, third-party systems,
                            data synchronization, and automated workflows across your
                            technology ecosystem.
                        </p>
                    )}

                    {activeIndex === 5 && (
                        <p className="text-[#49577A] text-[14px] lg:text-[16px] leading-relaxed font-[500] font-graphik animate-fade-in">
                            Expand your ServiceNow development capacity with
                            professionals experienced in scripting, business rules,
                            client scripts, UI policies, workflows, custom
                            applications, portals, and automation. Add specialized
                            development resources to support your ServiceNow roadmap
                            and project delivery.
                        </p>
                    )}

                </div>


                {/* IMAGE */}
                <div className="w-full h-[300px] lg:h-[378px] overflow-hidden relative">

                    <div className="absolute inset-0 bg-gradient-to-tr from-blue-100/50 to-transparent z-10 pointer-events-none"></div>

                    {activeIndex === 0 && (
                        <img
                            src="/assets/home-/ai-2.png"
                            alt="ServiceNow ITSM staff augmentation services"
                            className="w-full h-full object-cover transition-opacity duration-500 animate-[fadeIn_0.5s_ease-in-out_forwards]"
                        />
                    )}

                    {activeIndex === 1 && (
                        <img
                            src="/assets/home-/ai-3.png"
                            alt="ServiceNow ITOM and CMDB staff augmentation services"
                            className="w-full h-full object-cover transition-opacity duration-500 animate-[fadeIn_0.5s_ease-in-out_forwards]"
                        />
                    )}

                    {activeIndex === 2 && (
                        <img
                            src="/assets/home-/ai-4.png"
                            alt="ServiceNow CSM staff augmentation services"
                            className="w-full h-full object-cover transition-opacity duration-500 animate-[fadeIn_0.5s_ease-in-out_forwards]"
                        />
                    )}

                    {activeIndex === 3 && (
                        <img
                            src="/assets/home-/img1.png"
                            alt="ServiceNow HRSD staff augmentation services"
                            className="w-full h-full object-cover transition-opacity duration-500 animate-[fadeIn_0.5s_ease-in-out_forwards]"
                        />
                    )}

                    {activeIndex === 4 && (
                        <img
                            src="/assets/home-/img2.png"
                            alt="ServiceNow integration staff augmentation services"
                            className="w-full h-full object-cover transition-opacity duration-500 animate-[fadeIn_0.5s_ease-in-out_forwards]"
                        />
                    )}

                    {activeIndex === 5 && (
                        <img
                            src="/assets/home-/img3.png"
                            alt="ServiceNow custom development staff augmentation services"
                            className="w-full h-full object-cover transition-opacity duration-500 animate-[fadeIn_0.5s_ease-in-out_forwards]"
                        />
                    )}

                </div>

            </div>

        </div>
    </div>

    <style>{`
        @keyframes fadeIn {
            from {
                opacity: 0;
                transform: translateY(10px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }

        .animate-fade-in {
            animation: fadeIn 0.5s ease-out forwards;
        }
    `}</style>
</section>

<section className="w-full pb-[40px] md:pb-[100px] bg-white">
    <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">

        <div className="flex flex-col lg:flex-row items-start gap-[24px] md:gap-[40px] lg:gap-[80px]">

            {/* LEFT SIDE */}
            <motion.div
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{
                    duration: 0.8,
                    ease: "easeOut"
                }}
                className="w-full lg:w-5/12 lg:sticky lg:top-[120px]"
            >
                <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-[#01386A] tracking-tight leading-[1.2] lg:max-w-[350px]">
                    Frequently Asked Questions About ServiceNow Staff Augmentation
                </h2>
            </motion.div>


            {/* RIGHT SIDE */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{
                    once: true,
                    amount: 0.1
                }}
                transition={{
                    duration: 0.6,
                    ease: "easeOut"
                }}
                className="w-full lg:w-7/12 flex flex-col border border-[#E4E8F5] bg-white rounded-sm"
            >

                {servicenowFaqData.map((faq, index) => {

                    const isActive = faqActiveIndex === index;

                    return (
                        <div
                            key={faq.id}
                            className={`flex flex-col border-b ${
                                isActive
                                    ? "border-[#ED6800] border-b-[3px] md:border-b-[4px]"
                                    : "border-[#E4E8F5]"
                            } last:border-b-0 transition-colors duration-300`}
                        >

                            {/* QUESTION */}
                            <button
                                type="button"
                                onClick={() => toggleFaqAccordion(index)}
                                className="w-full flex justify-between items-center text-left py-[18px] sm:py-[24px] md:py-[32px] px-[16px] sm:px-[24px] md:px-[40px] group cursor-pointer bg-white md:hover:bg-[#F8FAFF] transition-colors duration-300"
                                aria-expanded={isActive}
                            >

                                <h3
                                    className={`font-sora max-w-[85%] text-[16px] md:text-[20px] font-[600] pr-[16px] sm:pr-[20px] transition-colors duration-300 ${
                                        isActive
                                            ? "text-[#01386A]"
                                            : "text-[#01386A] md:group-hover:text-[#ED6800]"
                                    }`}
                                >
                                    {faq.question}
                                </h3>


                                {/* PLUS / MINUS ICON */}
                                <div className="flex-shrink-0 text-[#01386A] transition-colors duration-300 md:group-hover:text-[#ED6800]">

                                    {isActive ? (

                                        <svg
                                            width="18"
                                            height="18"
                                            className="md:w-[20px] md:h-[20px]"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            aria-hidden="true"
                                        >
                                            <line
                                                x1="5"
                                                y1="12"
                                                x2="19"
                                                y2="12"
                                            />
                                        </svg>

                                    ) : (

                                        <svg
                                            width="18"
                                            height="18"
                                            className="md:w-[20px] md:h-[20px]"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            aria-hidden="true"
                                        >
                                            <line
                                                x1="12"
                                                y1="5"
                                                x2="12"
                                                y2="19"
                                            />

                                            <line
                                                x1="5"
                                                y1="12"
                                                x2="19"
                                                y2="12"
                                            />
                                        </svg>

                                    )}

                                </div>

                            </button>


                            {/* ANSWER */}
                            <AnimatePresence initial={false}>

                                {isActive && (

                                    <motion.div
                                        initial={{
                                            height: 0,
                                            opacity: 0
                                        }}
                                        animate={{
                                            height: "auto",
                                            opacity: 1
                                        }}
                                        exit={{
                                            height: 0,
                                            opacity: 0
                                        }}
                                        transition={{
                                            duration: 0.4,
                                            ease: "easeInOut"
                                        }}
                                        className="overflow-hidden bg-white"
                                    >

                                        <div className="pb-[20px] sm:pb-[32px] px-[16px] sm:px-[24px] md:px-[40px]">

                                            <p className="font-graphik text-[#6C7689] text-[14px] md:text-[16px] font-[500] leading-[1.6]">
                                                {faq.answer}
                                            </p>

                                        </div>

                                    </motion.div>

                                )}

                            </AnimatePresence>

                        </div>
                    );
                })}

            </motion.div>

        </div>

    </div>
</section>
   <ServiceNowLeadForm/>
<Banner
    title="ServiceNow Staff Augmentation Services"
    text="Scale your ServiceNow team with experienced developers, consultants, architects, administrators, and integration specialists to accelerate delivery and support your ServiceNow initiatives."
/>

    </div>
  )
}

export default ServiceNowStaffAugmentation
